let graphicLayer; //展示线标记和面标记功能临时用。

/* 异步加载 一些弹窗组件 */
const BimMonitorTree = () => import("./bimMonitorTree/BimMonitorTree");
const BimMonitorItemData = () =>
  import("./bimMonitorItemData/BimMonitorItemData.vue");

//按需加载
import {
  getBimMonitorTree,
  //getBimMonitorItemList,
  getBimMonitorPointDoubleDataList,
  getMonitorNonlinearityDetail,
  getMonitorCSDList,
} from "../../../api/api";

import { EventBus } from "../../../static/js/event-bus.js";

export default {
  components: {
    BimMonitorTree,
    BimMonitorItemData,
  },
  props: {},
  data() {
    return {
      bimMonitor_show: true,

      getData: [], //保存请求后台数据获取到的一维json数组【原始数组】
      treeData: [],
      treeExpandAll: true,
      treeNodeKey: "id",

      open_monitor_box: "", //当前打开的标记子弹窗，最多只同时显示一个子弹窗。
      isFold: false,
      openTemplateType: 0, //默认为0，打开面板为空，因此必须传入正确的1\2\3\4，才根据对应模板展示数据，避免出现混乱现象。
    };
  },
  mounted() {
    // alert(22)
    this.initTreeData();

    if (!this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({});
      this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer);
    }
  },

  methods: {
    // 初始化列表
    initTreeData() {
      //axios请求 获取数据 注意将parentId:'0'转为parentId:'',以方便el-tree正常识别和显示数据。此外注意将字段名首位字母改为小写。
      let tempdata = [];
      let that = this;

      let mTData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getBimMonitorTree(mTData).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          that.treeData = res.data.data;
          //console.log(JSON.parse(JSON.stringify(that.treeData)));
          //alert(1);
          //console.log(JSON.parse(JSON.stringify(that.treeData)));
        } else {
          that.getData = [];
          that.treeData = [];
        }
      });
    },
    //绘制监测标记点及文本到地图上，传入监测点标记点对象数组。
    drawPoints(arr) {
      //地图上画出该点。

      // 因数据不准，临时将高程减10000。
      let tempCartesanArr = [];
      arr.map((item) => {
        this.$GLOBAL.markDrawGraphicLayer.addGraphic([
          {
            type: "billboard",
            position: new mars3d.LngLatPoint(item.x, item.y, item.z - 10000),
            style: {
              image: "/img/marker/mark00ced1.png",
              label: {
                //不需要文字时，去掉label配置即可
                text: item.name,
                font_size: 26,
                font_family: "黑体",
                color: "#fff",
                outline: true,
                pixelOffsetY: -66, //使文本在图标上显示。
                visibleDepth: false,
              },
              visibleDepth: false,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
              //clampToGround: true, //贴地
              show: true,
            },
            show: true,
          },
        ]);
        tempCartesanArr.push(
          Cesium.Cartesian3.fromDegrees(item.x, item.y, item.z)
        );
      });

      // console.log(JSON.parse(JSON.stringify(arr)));
      // console.log(123);

      // 如果只有一个点，则定位到点。如果由多个点，则将经纬度转为笛卡尔直角坐标系坐标，然后根据整体的坐标去定位（应该可以适当保障一下相机视角居中对齐，效果更好）。
      this.$GLOBAL.map.flyToPositions(tempCartesanArr);
    },
    showBimMonitorItemData(data) {
      this.open_monitor_box = "";
      this.openTemplateType = 0;
      if (data?.monitorPointDoubleDataDto) {
        this.openTemplateType = 1; // 线型监测。
      }
      if (data?.monitorItemDto) {
        if (data.monitorItemDto.typeName === "线型监测") {
          this.openTemplateType = 2; // 线型监测、多断面展示。
        }
        if (data.monitorItemDto.typeName === "应力监测") {
          this.openTemplateType = 3; // 应力监测。
        }
        if (data.monitorItemDto.typeName === "沉降监测") {
          this.openTemplateType = 4; // 沉降监测。
        }
      }
      if (data?.monitorCategorySingleDataDto) {
        this.openTemplateType = 5; // 竖向、横向、水平监测。
      }

      //每次点击选项展示图表时都清空现有的地图上画出的其它监测点。
      this.$GLOBAL.markDrawGraphicLayer.clear(true);

      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(777);

      let getIDData = {
        id: data.id,
      };
      switch (this.openTemplateType) {
        case 1:
          let getmpdData = {
            projectId: window.sessionStorage.getItem("nowProjectId"),
            pid: data.parentId,
          };
          getBimMonitorPointDoubleDataList(getmpdData).then((res) => {
            if (res.data.success && res.data.data.length > 0) {
              let lMShowData = this.linearMonitoringDataProcessing(
                data,
                res.data.data
              );
              if (lMShowData && lMShowData.length > 0) {
                this.open_monitor_box = "BimMonitorItemData";
                this.$refs.bimMonitorItemData.initData(
                  this.openTemplateType,
                  lMShowData
                );

                // 地图上画出该点并定位。
                this.drawPoints([
                  {
                    x: data.monitorPointDoubleDataDto.x,
                    y: data.monitorPointDoubleDataDto.y,
                    z: data.monitorPointDoubleDataDto.z,
                    name: data.text,
                  },
                ]);

                //alert(data.monitorPointDoubleDataDto.x+','+data.monitorPointDoubleDataDto.y+','+data.monitorPointDoubleDataDto.z)
                return false;
              } else {
                this.$message({
                  message: "暂未查询到 " + data.text + " 的线型监测数据。",
                  type: "error",
                  offset: 100,
                  showClose: true,
                  duration: 1600,
                });
              }
            } else {
              this.$message({
                message: "暂未查询到 " + data.text + " 的线型监测数据。",
                type: "error",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
            }

            // console.log(JSON.parse(JSON.stringify(res.data)));
            // console.log(777);
          });
          break;
        case 2:
          let that = this;
          // 获取线型监测监测项的数据。注意监测项数据并不是监测项下监测点数据的集合。
          // let getILData={
          // 	itemId:data.id,
          // 	projectId:window.sessionStorage.getItem("nowProjectId"),
          // 	type:0,
          // }
          // getBimMonitorItemList(getILData).then(res=>{
          // 	console.log(JSON.parse(JSON.stringify(res.data)));
          // 	console.log(888);
          // })

          getMonitorNonlinearityDetail(getIDData).then((res) => {
            //console.log(JSON.parse(JSON.stringify(data.children)));
            //console.log(888);
            if (
              res.data.success &&
              res.data.data &&
              res.data.data.itemData.length > 0
            ) {
              this.open_monitor_box = "BimMonitorItemData";
              let useData = [];
              useData.push({
                name: data.text,
              });
              useData.push(res.data.data.itemData);
              // console.log(useData);
              // console.log(999);
              this.$refs.bimMonitorItemData.initData(
                this.openTemplateType,
                useData
              );

              //地图上画出所有相关的监测点并定位。
              let drawPointsArr = [];
              data.children.map((item2) => {
                drawPointsArr.push({
                  x: item2.monitorPointDoubleDataDto.x,
                  y: item2.monitorPointDoubleDataDto.y,
                  z: item2.monitorPointDoubleDataDto.z,
                  name: item2.monitorPointDoubleDataDto.name,
                });
              });
              this.drawPoints(drawPointsArr);
              //alert(data.monitorPointDoubleDataDto.x+','+data.monitorPointDoubleDataDto.y+','+data.monitorPointDoubleDataDto.z)
              return false;
            } else {
              this.$message({
                message: "暂未查询到 " + data.text + "下监测点的线型监测数据。",
                type: "error",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
            }
          });
          break;
        case 3:
          getMonitorNonlinearityDetail(getIDData).then((res) => {
            // console.log(JSON.parse(JSON.stringify(res.data)));
            // console.log(888);
            if (
              res.data.success &&
              res.data.data &&
              res.data.data.itemData.length > 0
            ) {
              this.open_monitor_box = "BimMonitorItemData";
              let useData = [];
              useData.push({
                name: data.text,
              });

              let tempOddMarr = []; // 奇数项。
              let tempEvenMarr = []; // 偶数项。

              res.data.data.itemData.map((item) => {
                item.sortBySelfField = parseInt(item.name); //将name里的数字提取出来，作为排序依据。这样做并不够严谨，后面可改成由后端新增一个确定的排序依据字段。
                if (item.type === 1) {
                  // type字段才是分组的依据。
                  // 应力监测-顶板纵向
                  tempOddMarr.push(item);
                } else {
                  // 应力监测-底板纵向
                  tempEvenMarr.push(item);
                }
              });
              tempOddMarr.sort((first, second) => {
                return first.sortBySelfField - second.sortBySelfField; //按照name中的数字来升序排序。
              });
              tempEvenMarr.sort((first, second) => {
                return first.sortBySelfField - second.sortBySelfField; //按照name中的数字来升序排序。
              });
              //useData.push(res.data.data.itemData);
              useData.push(tempOddMarr);
              useData.push(tempEvenMarr);
              // console.log(JSON.parse(JSON.stringify(useData)));
              // console.log(221);
              this.$refs.bimMonitorItemData.initData(
                this.openTemplateType,
                useData
              );
              //地图上也应该定位到该点,并在图上画出该监测点。

              //地图上画出所有相关的监测点并定位。
              //现在应力监测中监测点（板块）没有x、y、z数据，现在只绘制整体（桥梁）的一个点。
              // let drawPointsArr=[];
              // tempOddMarr.map((item2,index)=>{
              // 	let showIndex=index+1;
              // 	drawPointsArr.push({
              // 		x:item2.x,
              // 		y:item2.y,
              // 		z:item2.z,
              // 		name:'顶板'+showIndex,
              // 	})
              // })
              // tempEvenMarr.map((item2,index)=>{
              // 	let showIndex=index+1;
              // 	drawPointsArr.push({
              // 		x:item2.x,
              // 		y:item2.y,
              // 		z:item2.z,
              // 		name:'底板'+showIndex,
              // 	})
              // })
              //this.drawPoints(drawPointsArr);

              this.drawPoints([
                {
                  x: data.monitorItemDto.x,
                  y: data.monitorItemDto.y,
                  z: data.monitorItemDto.z,
                  name: data.text,
                },
              ]);

              // console.log(JSON.parse(JSON.stringify(drawPointsArr)));
              // console.log(221);

              //alert(data.monitorPointDoubleDataDto.x+','+data.monitorPointDoubleDataDto.y+','+data.monitorPointDoubleDataDto.z)
              return false;
            } else {
              this.$message({
                message: "暂未查询到 " + data.text + " 的应力监测数据。",
                type: "error",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
            }
          });
          break;
        case 4:
          getMonitorNonlinearityDetail(getIDData).then((res) => {
            // console.log(JSON.parse(JSON.stringify(res.data)));
            // console.log(878);
            if (
              res.data.success &&
              res.data.data &&
              res.data.data.itemData.length > 0
            ) {
              this.open_monitor_box = "BimMonitorItemData";
              res.data.data.itemData.forEach((item) => {
                item.diffValue *= 1000;
              });
              let useData = [];
              useData.push({
                name: data.text,
              });
              useData.push(res.data.data.itemData);
              // console.log(JSON.parse(JSON.stringify(useData)));
              // console.log(221);
              this.$refs.bimMonitorItemData.initData(
                this.openTemplateType,
                useData
              );

              //地图上画出所有相关的监测点并定位。
              //现在基础沉降监测中墩承台的x、y、z数据也没有，因此只绘制整体（墩）的一个标注点。
              // let drawPointsArr=[];
              // res.data.data.itemData.map(item2=>{
              // 	drawPointsArr.push({
              // 		x:item2.x,
              // 		y:item2.y,
              // 		z:item2.z,
              // 		name:item2.name,
              // 	})
              // })
              // this.drawPoints(drawPointsArr);

              this.drawPoints([
                {
                  x: data.monitorItemDto.x,
                  y: data.monitorItemDto.y,
                  z: data.monitorItemDto.z,
                  name: data.text,
                },
              ]);

              //alert(data.monitorPointDoubleDataDto.x+','+data.monitorPointDoubleDataDto.y+','+data.monitorPointDoubleDataDto.z)
              return false;
            } else {
              this.$message({
                message: "暂未查询到 " + data.text + " 的沉降监测数据。",
                type: "error",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
            }
          });
          break;
        case 5:
          let getCSDData = {
            projectId: window.sessionStorage.getItem("nowProjectId"),
            pid: data.parentId,
          };
          getMonitorCSDList(getCSDData).then((res) => {
            // console.log(JSON.parse(JSON.stringify(res.data)));
            // console.log(992);
            if (res.data.success && res.data.data) {
              this.open_monitor_box = "BimMonitorItemData";
              let useData = [];
              // 根据type为0、1、2分成三个数组。
              let nameArr = [[], [], []]; //存储所有的不同名字，作为分组依据。
              let tempArr = [[], [], []];
              let tempFIndex = -1;
              // 拆分数组，构建出图表可以直接展示出来的数据。。
              res.data.data.map((item) => {
                item.date = item.date.slice(0, 10); // 删除时分秒，只保留年月日，作为横轴展示名称。
                if (!nameArr[item.type].includes(item.name)) {
                  nameArr[item.type].push(item.name);
                  tempArr[item.type].push({
                    name: item.name + "/mm",
                    type: "line",
                    smooth: true,
                    dataArr: [],
                    data: [],
                  });
                }

                // 因为一定是从0开始顺序递增，所以不需要再对res.data.data遍历一次以处理下面的部分数据处理逻辑。
                tempFIndex = nameArr[item.type].findIndex((item2) => {
                  return item2 === item.name;
                });
                if (tempFIndex !== -1) {
                  tempArr[item.type][tempFIndex].dataArr.push(item);
                  tempArr[item.type][tempFIndex].data.push(
                    item.displacementValue
                  );
                }
              });
              // console.log(JSON.parse(JSON.stringify(tempArr)));
              // 后端数据可以确定是按照date来顺序排序的，所以这里就不需要对tempArr进行一次遍历来保障每一个监测点的数据是按照横轴date顺序排序的。

              useData.push({
                name: data.text,
              });
              useData.push(tempArr);
              //console.log(JSON.parse(JSON.stringify(useData)));
              //console.log(221);
              this.$refs.bimMonitorItemData.initData(
                this.openTemplateType,
                useData
              );

              //地图上画出所有相关的监测点并定位。
              let drawPointsArr = [];
              tempArr[0].map((item3) => {
                drawPointsArr.push({
                  x: item3.dataArr[0].x,
                  y: item3.dataArr[0].y,
                  z: item3.dataArr[0].z,
                  name: item3.dataArr[0].name,
                });
              });
              this.drawPoints(drawPointsArr);

              return false;
            } else {
              this.$message({
                message: "暂未查询到 " + data.text + " 的沉降监测数据。",
                type: "error",
                offset: 100,
                showClose: true,
                duration: 1600,
              });
            }
          });
          break;
        default:
          this.$message({
            message: "该节点的数据有误，无法为您展示其对应的监测数据。",
            type: "error",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
          break;
      }

      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(11111);
    },
    handleClose() {
      //this.videoDialogVisible=false;
    },
    bimMonitor_click() {
      this.$emit("bimMonitorBox_close");
    },
    //根据传入的点击项的信息和查询到的数据，提取出画线位监测图时的点数组信息。
    linearMonitoringDataProcessing(data, listData) {
      // 取出要展示到图表里的五个点的十条数据。
      // 根据sectionPointIndex的值确定点击项对应的点在五个点中的位置。
      // 根据sectionPointIndex的值和点击项对应的点在所有点中的位置，来确定如何补齐五个点。
      // 注意列表中的一个点对应结果集中的两条数据。
      // 这里默认认为listData里的数据是成双成对，没有错误的，所以程序里没有做进一步精细的逻辑判断【例如处理缺失数据的情况】。
      let getData = [];
      let dataIndex = listData.findIndex((item) => {
        return data.id === item.connectId;
      });
      if (dataIndex !== -1) {
        let beginIndex = 0;
        let sliceNumber = 10;
        let diffValue1, diffValue2;
        let sectionPointIndex = listData[dataIndex].sectionPointIndex;
        if ([1, 2, 3, 4, 5].includes(sectionPointIndex)) {
          diffValue1 = dataIndex - 2 * (sectionPointIndex - 1);
          diffValue2 =
            listData.length - dataIndex - 2 * (6 - sectionPointIndex);
          if (diffValue1 >= 0) {
            beginIndex = diffValue1;
          }
          // console.log('sectionPointIndex:'+sectionPointIndex)
          // console.log('diffValue1:'+diffValue1)
          // console.log('test:'+beginIndex)
          let tempArr = [];
          if (diffValue2 < 0) {
            tempArr = listData.slice(beginIndex);
          } else {
            tempArr = listData.slice(beginIndex, beginIndex + sliceNumber);
          }

          // 接着继续对数据进行处理，转换成展示图表时可以直接拿过来用的数据。
          let tempOddArr = []; // 浇筑混凝土后。
          let tempEvenArr = []; // 预应力张拉后。
          let currentPointArr = [
            listData[dataIndex],
            listData[dataIndex + 1],
          ].sort((a, b) => {
            return a.type - b.type;
          }); //当前点测量值。

          tempArr.map((item, index) => {
            // if(index % 2 === 0){
            // 	tempOddArr.push(item);
            // }else{
            // 	tempEvenArr.push(item);

            // 接口里的数据虽然成双成对，但是type值的顺序却不是固定的，而type字段才是分组的依据。
            if (item.type === 0) {
              tempOddArr.push(item);
            } else {
              tempEvenArr.push(item);
            }
          });
          getData.push(tempOddArr);
          getData.push(tempEvenArr);
          getData.push(currentPointArr);
          return getData;
        } else {
          return [];
        }
        // console.log(dataIndex);
        //console.log(getData);
        //console.log(listData[dataIndex]);
      } else {
        return [];
      }

      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(JSON.parse(JSON.stringify(listData)));
      // console.log(11111);
    },
  },
  watch: {},
  destroyed() {
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
  },
};
//console.log(localStorage.getItem(ColorPicker));
